import { Controller } from 'stimulus'
import { dayLabel }   from '@react/helpers/day_label'

const GROUP_GAP_MS = 5 * 60 * 1000

// Messages arrive live, so day pills and grouping are redone whenever the thread changes.
export default class extends Controller {
  connect() {
    this.layout = this.layout.bind(this)
    this.observer = new MutationObserver(this.layout)
    this.layout()
  }

  disconnect() {
    this.observer.disconnect()
  }

  layout() {
    this.observer.disconnect()

    this.element.querySelectorAll('[data-ticket-day]').forEach(divider => divider.remove())

    const breaks = [...this.element.querySelectorAll('.ticket-ai-divider')]
    let previous = null

    this.element.querySelectorAll('.logs__message[data-at]').forEach(row => {
      const at  = new Date(row.dataset.at)
      const day = at.toDateString()

      if (!previous || previous.day !== day) {
        const anchor = row.closest('[id^="message_"]') || row
        anchor.parentNode.insertBefore(this.dayDivider(at), anchor)
      }

      const continued = previous &&
        previous.day === day &&
        previous.key === row.dataset.authorKey &&
        at - previous.at < GROUP_GAP_MS &&
        !breaks.some(divider => this.between(previous.row, divider, row))

      row.classList.toggle('logs__message--continued', !!continued)
      previous = { row, day, at, key: row.dataset.authorKey }
    })

    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  between(first, node, last) {
    return (first.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_FOLLOWING) &&
           (node.compareDocumentPosition(last) & Node.DOCUMENT_POSITION_FOLLOWING)
  }

  dayDivider(date) {
    const divider = document.createElement('div')
    divider.className = 'ticket-ai-divider'
    divider.dataset.ticketDay = 'true'

    const label = document.createElement('span')
    label.className = 'ticket-ai-divider__label'
    label.textContent = dayLabel(date)

    divider.appendChild(label)
    return divider
  }
}
